<template>
    <div :class="['task-field mr-3', errorMessages ? 'field-error' : '']">
        <div class="global-label">
            <UsersMenu
                ref="assigneesField"
                v-slot="{ on, menuOpen }"
                :value="value"
                :items="items"
                @change="onChange"
            >
                <v-btn text dense class="global-label" v-on="on">
                    {{ button_label }}
                    <icon :icon="menuOpen ? 'ChevronUp' : 'ChevronDown'" small />
                </v-btn>
            </UsersMenu>
        </div>
        <div>
            <v-checkbox
                v-model="i_follow" 
                class="mt-0 pt-1" 
                :label="$t('Follow')" 
                color="n4" 
                hide-details
                dense 
                @change="followClick"
            ></v-checkbox>
        </div>
        <div v-if="!!errorMessages" :class="['details', errorMessages ? 'error--text' : '']">
            {{ errorMessages }}
        </div>
    </div>
</template>

<script>
import { computed, watch, ref } from "@vue/composition-api";
import { $t } from "@/i18n";
import AccountModule from "@/store/modules/account";
import UsersMenu from "../components/UsersField/UsersMenu.vue";
import { formatNumber } from "@/plugins/formatting";

export default {
    name: "FollowersField",
    components: {
        UsersMenu
    },
    props: {
        label: {
            type: String,
            default: null
        },
        value: {
            type: Array,
            required: true,
        },
        items: {
            type: Array,
            required: true
        },
        errorMessages: {
            type: String,
            default: null
        },
    },
    setup(props, ctx) {
        const { current_account } = AccountModule();

        const i_follow = ref(false);

        const button_label = computed(() => {
            return props.label + (props.value.length > 0 ? " ({0})".format(formatNumber(props.value.length)) : "");
        });

        watch(
            () => props.value, 
            () => {
                i_follow.value = !!props.value.find(x => x === current_account.value.id)
            }
        );

        const followClick = (follow) => {
            if (follow){
                onChange([...props.value, current_account.value.id])
            } else {
                onChange(props.value.filter(id => id !== current_account.value.id))
            }
        };
        const onChange = val => {
            ctx.emit("change", val);
        };

        return {
            i_follow,
            button_label,
            followClick,
            onChange
        };
    }
}
</script>
<style lang="scss" scoped>
::v-deep .v-input__slot .v-input--selection-controls__input {
    margin-right: 8px;
}
</style>